import React from 'react';
import { Link as LinkRouter } from "gatsby"
// import { animateScroll } from 'react-scroll';
import './footer.styles.scss';
import hookLogo from '../../assets/images/blue-hook-icon.png';
import { FaLinkedin, FaFacebook } from 'react-icons/fa';

const Footer = () => {

    // const toggleBlog = () => {
    //     animateScroll.scrollToTop();
    // };

    return (
        <section className='footer-container'>
            <div className='footer-wrapper'>
                <div className='footer-items'>
                    <div className='footer-items-title'>
                        <h4>Hooklab</h4>
                    </div>
                    <div className='footer-items-links'>
                        <a href='https://hooklab.com.br/'>Sobre</a>
                        <LinkRouter to='/' >Blog</LinkRouter>
                        <a href='https://hooklab.com.br/planos'>Planos</a>
                        <a href='https://hooklab.com.br/demonstracao'>Demonstração gratuita</a>
                    </div>
                </div>
                <div className='footer-items'>
                    <div className='footer-items-title'>
                        <h4>Produtos</h4>
                    </div>
                    <div className='footer-items-links'>
                        <a href='https://hooklab.com.br/solucoes/monitoramento-de-concorrentes'>Monitoramento de Concorrentes</a>
                        <a href='https://hooklab.com.br/solucoes/monitoramento-de-revendedores'>Monitoramento de Revendedores</a>
                        <a href='https://hooklab.com.br/solucoes/monitoramento-netshoes'>Monitoramento Netshoes</a>
                        <a href='https://hooklab.com.br/solucoes/precificacao-dinamica'>Precificação Dinâmica</a>
                        <a href='https://hooklab.com.br/solucoes/solucoes-personalizadas'>Soluções Personalizadas</a>
                        <a href='https://hooklab.com.br/privacidade'>Política de Privacidade</a>
                    </div>
                </div>
                <div className='footer-items'>
                    <div className='footer-items-title'>
                        <h4>Redes sociais</h4>
                    </div>
                    <div className='footer-items-links'>
                        <a href='https://www.linkedin.com/company/hooklab/' target='_blank'>Linkedin</a>
                        <a href='https://www.facebook.com/hooklabonline' target='_blank'>Facebook</a>
                    </div>
                </div>
            </div>
            <div className='footer-bottom'>
                <div className='footer-logo'>
                    <a href='https://hooklab.com.br/'><img src={hookLogo} /><span>hook</span><span className='blue'>lab</span></a>
                </div>
                <div className='footer-copyright'>
                    Hooklab © {new Date().getFullYear()} Todos os direitos reservados.
                </div>
                <div className='footer-icons'>
                    <a href='https://www.linkedin.com/company/hooklab/' target='_blank'><FaLinkedin /></a>
                    <a href='https://www.facebook.com/hooklabonline' target='_blank'><FaFacebook /></a>
                </div>
            </div>
        </section>
    )
}

export default Footer;